import {Link} from "react-router-dom";
import {Button, Container, Group, Stack, Text, Title} from "@mantine/core";

function NotFound() {
    return (
        <Container size="sm" py={80}>
            <Stack align="center" gap="md">
                <Text fw={800} size="72px" c="dimmed">404</Text>
                <Title order={2} ta="center">We couldn't find that page.</Title>
                <Text c="dimmed" ta="center">
                    The link may be out of date. Our products are a good place to start.
                </Text>
                <Group mt="md">
                    <Button component={Link} to="/products" radius="xl" color="brand.6">
                        View products
                    </Button>
                    <Button component={Link} to="/home" radius="xl" variant="light" color="brand">
                        Go home
                    </Button>
                </Group>
            </Stack>
        </Container>
    );
}

export default NotFound;
